import { AdminManagementDialogTypes } from "../components/AdminManagement/Dialogs/AdminManagementDialog";

export interface KursBelegung {
  ID_Belegung: number;
  Kursname: string;
  Kurzbezeichnung: string;
  Displayname: string;
  Mitgliedschaftsbeginn: Date;
  Mitgliedschaftsende: Date;
  IsAud: boolean;
}

export interface Mitglied {
  ID: number;
  Nachname: string;
  Vorname: string;
  Geschlecht: string;
  Geburtsdatum: Date;
  Strasse: string;
  PLZ: string;
  Stadt: string;
  Telefonnummer: string;
  Emailadresse: string;
  Kontoinhaber: string;
  IBAN: string;
  Hinzugefuegt: Date;
  Mitgliedschaftsbeginn: Date;
  Mitgliedschaftsende: Date;
  Belegungen: KursBelegung[];
}

export interface Standort {
  ID: number;
  Standortname: string;
  Strasse: string;
  PLZ: string;
  Ort: string;
  Ansprechpartner: string;
  Kontakt: string;
  Kurse: Kurs[];
}

export interface Kurs {
  ID: number;
  Kursname: string;
  Displayname: string;
  Bereich: string;
  Kurzbezeichnung: string;
  Wochentag: string;
  Anfangsuhrzeit: string;
  Enduhrzeit: string;
  Alter: string;
  Eltern: boolean;
  Bemerkung: string;
  ID_Ort: number;
  ID_Trainer: number;
  max_Teilnehmer: number;
  Status: boolean;
  Mitgliedsbeitrag: number;
  Aufnahmegebuehr: number;
  Kontingentierbar: boolean;
}

export interface Warteliste {
  ID: number;
  Kursname: string;
  Kurzbezeichnung: string;
  MaxTeilnehmer: string;
  WartelistenKundenData: WartelistenKundenData[];
}

export interface WartelistenKundenData {
  ID_Kurs: number;
  ID: number;
  ID_KUNDE_NOT_VERIFIED: number;
  aktiv: boolean;
  created: Date;
  issued: Date;
  verifiedAt: Date;
  version: number;
  Nachname: string;
  Vorname: string;
  Geschlecht: string;
  Geburtsdatum: Date;
  Strasse: string;
  PLZ: string;
  Stadt: string;
  Telefonnummer: string;
  Emailadresse: string;
  Kontoinhaber: string;
  IBAN: string;
  Hinzugefuegt: Date;
}

export interface BelegbarerKurs {
  ID: number;
  KursName: string;
}

export interface BelegbareKurseResponse {
  volleKurse: BelegbarerKurs[];
  verfugbareKurse: BelegbarerKurs[];
}

export enum SearchTypes {
  STANDORT = "STANDORT",
  WARTELISTE = "WARTELISTE",
  MITGLIED = "MITGLIED",
  TRAINER = "TRAINER",
  MAHNUNG = "MAHNUNG",
}

export interface SearchObject {
  type: SearchTypes;
  query: string;
}

export interface IdAndDataType {
  ID: number;
  data: string;
}

export interface FieldConfig {
  attribute: string;
  data: string;
  type: AdminManagementDialogTypes;
  validatorFct?: ValidatorFunction;
  isRequired?: boolean;
}

export interface InputData {
  [categoryKey: string]: {
    [key: string]: FieldConfig;
  };
}

export type ValidatorFunction = (
  value: string,
  isRequired: boolean
) => boolean | Promise<boolean>;

export enum AdminManagementDialogKey {
  MITGLIED,
  STANDORT,
  KURS,
  WARTELISTE,
  BELEGUNG,
  MAHNUNG,
}

/** Mahnung */
export enum MahnstufeEnum {
  LEER = -1,
  ZAHLUNGSERINNERUNG = 0,
  MAHNSTUFE_1 = 1,
  MAHNSTUFE_2 = 2,
  INKASSO_SCHUFA = 3,
}

export interface Belegungen {
  ID_Belegungen: number;
  ID_Kurs: number;
  ID_Kunde: number;
  Mitgliedschaftsbeginn: Date;
  Mitgliedschaftsende: Date | null;
  aktiv: boolean;
  zahler: boolean;
}

export interface Kundenstamm {
  ID_Kunde: number;
  Nachname: string;
  Vorname: string;
  Geschlecht: string;
  Geburtsdatum: Date;
  Strasse: string;
  PLZ: string;
  Stadt: string;
  Telefonnummer: string;
  Emailadresse: string;
  Kontoinhaber: string;
  IBAN: string;
  Hinzugefuegt: Date;
}

export const MahnungStatusTitleMap = {
  0: "Eingestellt",
  1: "Aktiv",
  2: "Import",
  3: "Inkasso",
  4: "Bezahlt",
};

export enum GebuhrTypes {
  AUFNAHME = "AUFNAHME",
  BEITRAG = "BEITRAG",
  RUCKLAST = "RUCKLAST",
  MAHN = "MAHN",
}

export enum ErefValues {
  BEITRAG = "Beitrag",
  AUFNAHME = "Aufnahme",
}

export enum MahnungStatus {
  STOPPED = 0,
  ACTIVE = 1,
  IMPORT = 2,
  INKASSO = 3,
  PAID = 4,
}

export interface Mahngebuhr {
  ID_Mahngebuhr: number;
  ID_Mahnung: number;
  Gebuhrtype: GebuhrTypes;
  Gebuhr: number;
  Datum: Date;
}

export interface Mahnung {
  ID: number;
  ID_Mahnung: number;
  ID_Belegung: number;
  ID_Kunde: number;
  Vorname: string;
  Nachname: string;
  createdDate: string;
  updateDate: string;
  Mahnstufe: MahnstufeEnum;
  Mahnfrist: Date | null;
  Status: MahnungStatus;
  IstExportiert: boolean;
  Notizen: string | null;
  Mahngebuhren: Mahngebuhr[];
  Summe: number;
}
